import 'isomorphic-fetch';

import { receiveGlobalMeta, getCacheBuster } from 'Actions/MetaActions';
import { getLoadingBehavior, shouldNotUpdateState, updatePagesResult, fetchSuccess } from 'Actions/InfiniteScrollActions';
import { setLastGlobalAction, setGlobalNotification, backInHistory, getFetchConfig } from 'Actions/GlobalMetaActions';
import { trackGAEvent } from 'Actions/adsActions';
import { mapLoadingBehaviour, getPageSize } from 'Actions/UserSettingsActions';
import { responseNormalizer, updateUstate } from 'Actions/responseNormalizer';

import {
	requestSearch,
	receiveSearch,
	failedSearch
} from 'Common/actions/SearchResultActions';

export * from 'Common/actions/SearchResultActions';

export function fetchSearch( searchRequest, cacheBust = false ) {
	return function(dispatch, getState) {
		let action = '';
		switch( searchRequest.id ) {
			case 'fav':
				action = 'fav';
				break;
			case 'participated':
			case 'part':
				action = 'participated';
				break;
			case 'updated':
			case 'unread':
				action = 'updated';
				break;
			case 'latest':
			case 'new':
				action = 'latest';
				break;
		}

		searchRequest.loadingBehavior = getLoadingBehavior( getState, action, "search", searchRequest.page, searchRequest.forceRefresh );

		if( shouldNotUpdateState( getState, searchRequest ) ) {
			dispatch( updatePagesResult( searchRequest.page || 1 ) );
			return null;
		}

		dispatch( requestSearch( searchRequest ) );

		const state = getState();
		const url = state.topifyPresets.forumSite.url;

		let showPosts = searchRequest.showposts ? '&showposts=' + searchRequest.showposts : '',
			searchForum = searchRequest.forumId ? `&sf=${searchRequest.forumId}` : '',
			searchId = searchRequest.searchId ? `&searchid=${searchRequest.searchId}` : '',
			searchQuery = searchRequest.searchQuery ? '&sq=' + searchRequest.searchQuery : '',
			id = searchRequest.id ? `&id=${searchRequest.id}` : '',
			userID = state.ustate.id ? state.ustate.id : 0,
			reqType = searchRequest.id === 'fav' ? 'fav' : 'search',
			showTopics = searchRequest.showtopics ? '&showtopics=' + searchRequest.showtopics : '';

		// Avoid Cache if cacheBust is required
		let fetchConfig = dispatch( getFetchConfig( cacheBust ) ),
			cacheBustQueryString = '&_=' + ( cacheBust ? cacheBust : ( getCacheBuster( getState ) || 0 ) ),
			lb = mapLoadingBehaviour( state.ui.userSettings.loadingBehavior ),
			page_size = dispatch( getPageSize() ),
			search_query_url = `${url}?v=3.0&ajax=1&uid=${ userID }&req=${reqType}${id}${showPosts}${showTopics}${searchId}${searchForum}${searchQuery}&pagesize=${page_size}&page=${searchRequest.page}&lb=${ lb }${ cacheBustQueryString }`;

		return fetch(search_query_url, fetchConfig )
			.then((response) => {
				if (!response.ok) {
					try {
						response.json().then((json) => {
							setGlobalNotification( dispatch, json, response );
						});
					} catch( e ) {
						setGlobalNotification( dispatch, {}, response );
					}

					dispatch(failedSearch(searchRequest, 'Bad response from server'));
					dispatch( backInHistory() );

				} else {
					response.json()
						.then((json) => {
							setGlobalNotification( dispatch, json, { ok: true } );

							if( searchRequest.forumId !== null ) {
								// Record the Google Analytics event and for the forum.
								dispatch( trackGAEvent( true, 'searchForum', 'userAction', 'consumption' ) );
							}

							let searchData = ( json.search && json.search.data.length > 0 ? json.search.data[ 0 ] : false ),
								other = Object.assign(
									{},
									{
										page: searchRequest.page,
										searchId: ( searchData ? parseInt( searchData.id ) : 0 ),
										query: {
											searchQuery: ( searchData ? searchData.query : null ) || searchRequest.searchQuery,
											showposts: ( searchData && searchData.showposts ? searchData.showposts : 0 ),
											forumId: ( searchData && searchData.searchForum || null ),
											action: ( reqType === 'fav' ? reqType : ( searchData && searchData.action || null ) ),
											showtopics: searchRequest.showtopics || null
										}
									},
									(json.search ? json.search.meta : json.following.meta)
								);

							let result = responseNormalizer( json, searchRequest.page, other );

							if( result.commonwords === null ) {
								result.commonwords = [];
							}

							// Preventing error on breadcrumb
							if( json.search && json.search.meta.path === null ) {
								json.search.meta.path = [];
							}

							dispatch( updateUstate( json, result ) );

							let action = json.search && json.search.data && json.search.data.length > 0 ? json.search.data[ 0 ].action : searchRequest.id;

							switch( action ) {
								case 'fav':
									dispatch( receiveGlobalMeta( state.meta, "Subscribed", state.topifyPresets.forumSite.f_title ) );
									break;
								case 'participated':
								case 'part':
									dispatch( receiveGlobalMeta( state.meta, "Participated", state.topifyPresets.forumSite.f_title ) );
									break;
								case 'updated':
								case 'unread':
									dispatch( receiveGlobalMeta( state.meta, "Topics With New Posts", state.topifyPresets.forumSite.f_title ) );
									break;
								case 'latest':
								case 'new':
									dispatch( receiveGlobalMeta( state.meta, "Active Topics", state.topifyPresets.forumSite.f_title ) );
									break;
								default:
									result.query.action = 'search';
									dispatch( receiveGlobalMeta( json.search.meta, "Search Results" ) );
							}

							dispatch( fetchSuccess( action, "search", searchRequest.page, result.totalPages, searchRequest.loadingBehavior ) );
							dispatch( receiveSearch( searchRequest, result ) );
						}
					)
				}
			}
		).then(()=>{
			setLastGlobalAction( 'search', searchRequest );

		}).catch( (error) => {
			setGlobalNotification(dispatch,{},error);
			dispatch(failedSearch(searchRequest, 'Bad response from server'));
			dispatch( backInHistory() );
		});
	}
}



// WEBPACK FOOTER //
// ./src/actions/SearchResultActions.js